import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { t } from 'i18next';
import { getProductId } from 'features/product-info';
import { getWishlist } from 'features/wishlist';
import { WISHLIST_ITEM_FLOW } from 'features/wishlist/ducks/actions';
import { showNotification, WishlistCheckboxButton } from '@navi-toolbox/ui-components';
import { useBreakpoints } from 'common/hooks';
import { NotificationTemplates } from 'common/components/notification-template-factory/types';

export type Props = {
  productDataIsLoading: boolean;
};

export const WishlistButton: React.FC<Props> = ({ productDataIsLoading }) => {
  const dispatch = useDispatch();
  const breakpoints = useBreakpoints();
  const productId = useSelector(getProductId) || '';
  const isDesktop = breakpoints?.largeDesktop || breakpoints?.desktop;

  const isInWishlistSelector = (pid?: string) =>
    createSelector(getWishlist, (wishlist) => wishlist?.some(({ code }) => code === pid)) || false;
  const isInWishlist = useSelector(isInWishlistSelector(productId));

  const text = isInWishlist ? t('ui.buttons.shopping-list-added') : t('ui.buttons.shopping-list-add');
  const tooltipText = isInWishlist
    ? t('ui.buttons.shopping-list-tooltip-remove')
    : t('ui.buttons.shopping-list-tooltip-add');

  const changeHandler = () => {
    dispatch(WISHLIST_ITEM_FLOW({ productId, flowQty: !isInWishlist ? 1 : -1 }));
    showNotification({
      templateId: NotificationTemplates.WishList,
      data: {
        title: isInWishlist
          ? t('ui.buttons.shopping-list-snack-remove')
          : t('ui.buttons.shopping-list-snack-add'),
      },
    });
  };

  return (
    <WishlistCheckboxButton
      isChecked={isInWishlist}
      isInteractive={!productDataIsLoading}
      size="l"
      text={text}
      isDesktop={isDesktop}
      tooltipText={tooltipText}
      onClick={changeHandler}
    />
  );
};
